import { PermissionEnum } from '@/constants/permission'

export const PagePermission = {
  COMPANY_LIST: [PermissionEnum.ADMIN_COMPANY_LIST],
  COMPANY_CREATE: [PermissionEnum.ADMIN_COMPANY_SHOW, PermissionEnum.ADMIN_COMPANY_CREATE],
  COMPANY_UPDATE: [PermissionEnum.ADMIN_COMPANY_UPDATE],
  COMPANY_OVERVIEW: [PermissionEnum.ADMIN_COMPANY_SHOW],

  CLINIC_LIST: [PermissionEnum.ADMIN_CLINIC_LIST],
  CLINIC_OVERVIEW: [PermissionEnum.ADMIN_CLINIC_SHOW],
  CLINIC_CREATE: [PermissionEnum.ADMIN_CLINIC_CREATE],
  CLINIC_UPDATE: [PermissionEnum.ADMIN_CLINIC_SHOW, PermissionEnum.ADMIN_CLINIC_UPDATE],

  ADMIN_USER_LIST: [PermissionEnum.ADMIN_USER_LIST],
  ADMIN_USER_OVERVIEW: [PermissionEnum.ADMIN_USER_SHOW],
  ADMIN_USER_CREATE: [PermissionEnum.ADMIN_USER_CREATE],
  ADMIN_USER_UPDATE: [PermissionEnum.ADMIN_USER_SHOW, PermissionEnum.ADMIN_USER_UPDATE],

  USER_LIST: [PermissionEnum.USER_LIST],
  USER_OVERVIEW: [PermissionEnum.USER_SHOW],

  DOCTOR_LIST: [PermissionEnum.DOCTOR_LIST],
  DOCTOR_OVERVIEW: [PermissionEnum.DOCTOR_SHOW],

  ADMIN_DOCTOR_LIST: [PermissionEnum.ADMIN_DOCTOR_LIST],
  ADMIN_DOCTOR_OVERVIEW: [PermissionEnum.ADMIN_DOCTOR_SHOW],
  ADMIN_DOCTOR_CREATE: [PermissionEnum.ADMIN_DOCTOR_CREATE],
  ADMIN_DOCTOR_UPDATE: [PermissionEnum.ADMIN_DOCTOR_SHOW, PermissionEnum.ADMIN_DOCTOR_UPDATE],

  ADMIN_QUALIFICATION_TYPE_LIST: [PermissionEnum.ADMIN_QUALIFICATION_TYPE_LIST],
  ADMIN_QUALIFICATION_TYPE_CREATE: [PermissionEnum.ADMIN_QUALIFICATION_TYPE_CREATE],
  ADMIN_QUALIFICATION_TYPE_UPDATE: [
    PermissionEnum.ADMIN_QUALIFICATION_TYPE_UPDATE,
    PermissionEnum.ADMIN_QUALIFICATION_TYPE_SHOW,
  ],

  NURSE_LIST: [PermissionEnum.NURSE_LIST],
  NURSE_SHOW: [PermissionEnum.NURSE_SHOW],

  ADMIN_NURSE_LIST: [PermissionEnum.ADMIN_NURSE_LIST],
  ADMIN_NURSE_SHOW: [PermissionEnum.ADMIN_NURSE_SHOW],
  ADMIN_NURSE_CREATE: [PermissionEnum.ADMIN_NURSE_CREATE],
  ADMIN_NURSE_UPDATE: [PermissionEnum.ADMIN_NURSE_UPDATE],

  TASK_LIST: [PermissionEnum.TASK_LIST],
  TASK_OVERVIEW: [PermissionEnum.TASK_SHOW, PermissionEnum.TASK_COMMENT_LIST],
  TASK_CREATE: [PermissionEnum.TASK_CREATE],
  TASK_UPDATE: [PermissionEnum.TASK_SHOW, PermissionEnum.TASK_UPDATE],

  APPOINTMENT_TYPE_LIST: [PermissionEnum.ADMIN_APPOINTMENT_TYPE_LIST],
  APPOINTMENT_TYPE_CREATE: [PermissionEnum.ADMIN_APPOINTMENT_TYPE_CREATE],
  APPOINTMENT_TYPE_UPDATE: [PermissionEnum.ADMIN_APPOINTMENT_TYPE_SHOW, PermissionEnum.ADMIN_APPOINTMENT_TYPE_UPDATE],

  ICD_10_TRENDING: [PermissionEnum.ICD_10_TRENDING_LIST, PermissionEnum.ICD_10_TREE],

  ADMIN_ICD_10_TRENDING: [PermissionEnum.ADMIN_ICD_10_TRENDING_LIST, PermissionEnum.ADMIN_ICD_10_TREE],

  ADMIN_EXAMINATION_LIST: [PermissionEnum.ADMIN_EXAMINATION_LIST],
  ADMIN_EXAMINATION_OVERVIEW: [PermissionEnum.ADMIN_EXAMINATION_SHOW],
  ADMIN_EXAMINATION_CREATE: [PermissionEnum.ADMIN_EXAMINATION_CREATE],
  ADMIN_EXAMINATION_UPDATE: [PermissionEnum.ADMIN_EXAMINATION_SHOW, PermissionEnum.ADMIN_EXAMINATION_UPDATE],

  ADMIN_TREATMENT_LIST: [PermissionEnum.ADMIN_TREATMENT_LIST],
  ADMIN_TREATMENT_OVERVIEW: [PermissionEnum.ADMIN_TREATMENT_SHOW],
  ADMIN_TREATMENT_CREATE: [PermissionEnum.ADMIN_TREATMENT_CREATE],
  ADMIN_TREATMENT_UPDATE: [PermissionEnum.ADMIN_TREATMENT_SHOW, PermissionEnum.ADMIN_TREATMENT_UPDATE],

  ADMIN_MEDICINAL_ATTENTION_LIST: [PermissionEnum.ADMIN_MEDICINAL_ATTENTION_LIST],
  ADMIN_MEDICINAL_INSTRUCTION_LIST: [PermissionEnum.ADMIN_MEDICINAL_INSTRUCTION_LIST],
  ADMIN_MEDICINAL_FORM_LIST: [PermissionEnum.ADMIN_MEDICINAL_FORM_LIST],
  ADMIN_MEDICINAL_ROUTE_LIST: [PermissionEnum.ADMIN_MEDICINAL_ROUTE_LIST],
  ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_LIST: [
    PermissionEnum.ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_LIST,
  ],
  ADMIN_MEDICINAL_CLASSIFICATION_LIST: [PermissionEnum.ADMIN_MEDICINAL_CLASSIFICATION_LIST],
  ADMIN_MEDICINAL_CATEGORY_LIST: [PermissionEnum.ADMIN_MEDICINAL_CATEGORY_LIST],

  UNIT_LIST: [PermissionEnum.ADMIN_UNIT_LIST],

  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_LIST: [PermissionEnum.ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_LIST],
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_OVERVIEW: [PermissionEnum.ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_SHOW],
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_CREATE: [PermissionEnum.ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_CREATE],
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_UPDATE: [
    PermissionEnum.ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_UPDATE,
    PermissionEnum.ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_SHOW,
  ],
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_DELETE: [PermissionEnum.ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_DELETE],

  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_LIST: [PermissionEnum.ADMIN_VIRTUAL_MEDICINAL_PRODUCT_LIST],
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_OVERVIEW: [PermissionEnum.ADMIN_VIRTUAL_MEDICINAL_PRODUCT_SHOW],
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_CREATE: [PermissionEnum.ADMIN_VIRTUAL_MEDICINAL_PRODUCT_CREATE],
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_UPDATE: [
    PermissionEnum.ADMIN_VIRTUAL_MEDICINAL_PRODUCT_UPDATE,
    PermissionEnum.ADMIN_VIRTUAL_MEDICINAL_PRODUCT_SHOW,
  ],

  ADMIN_MEDICINE_LIST: [PermissionEnum.ADMIN_MEDICINE_LIST],
  ADMIN_MEDICINE_OVERVIEW: [PermissionEnum.ADMIN_MEDICINE_SHOW],
  ADMIN_MEDICINE_CREATE: [PermissionEnum.ADMIN_MEDICINE_CREATE],
  ADMIN_MEDICINE_UPDATE: [PermissionEnum.ADMIN_MEDICINE_SHOW, PermissionEnum.ADMIN_MEDICINE_UPDATE],

  ADMIN_INJECTION_LIST: [PermissionEnum.ADMIN_INJECTION_LIST],
  ADMIN_INJECTION_OVERVIEW: [PermissionEnum.ADMIN_INJECTION_SHOW],
  ADMIN_INJECTION_CREATE: [PermissionEnum.ADMIN_INJECTION_CREATE],
  ADMIN_INJECTION_UPDATE: [PermissionEnum.ADMIN_INJECTION_SHOW, PermissionEnum.ADMIN_INJECTION_UPDATE],

  ADMIN_VACCINE_LIST: [PermissionEnum.ADMIN_VACCINE_LIST],
  ADMIN_VACCINE_OVERVIEW: [PermissionEnum.ADMIN_VACCINE_SHOW],
  ADMIN_VACCINE_CREATE: [PermissionEnum.ADMIN_VACCINE_CREATE],
  ADMIN_VACCINE_UPDATE: [PermissionEnum.ADMIN_VACCINE_SHOW, PermissionEnum.ADMIN_VACCINE_UPDATE],

  MEDICAL_RECORD: [PermissionEnum.MEDICAL_RECORD_SHOW],

  PATIENT_VITAL_CHECK_LIST: [PermissionEnum.PATIENT_VITAL_CHECK_LIST],
  PATIENT_VITAL_CHECK_OVERVIEW: [PermissionEnum.PATIENT_VITAL_CHECK_SHOW],
  PATIENT_VITAL_CHECK_UPDATE: [
    PermissionEnum.PATIENT_VITAL_CHECK_SHOW,
    PermissionEnum.NURSE_PATIENT_VITAL_CHECK_UPDATE,
  ],

  PATIENT_VISIT_LIST: [PermissionEnum.PATIENT_VISIT_LIST],

  APPOINTMENT_SETTING: [PermissionEnum.CLINIC_BOOKING_TIME_SHOW],
  APPOINTMENT_CALENDAR: [PermissionEnum.BOOKING_CALENDAR],

  PRINTER_GATEWAY_LIST: [PermissionEnum.CLINIC_PRINTER_GATEWAY_LIST],
  PRINTER_GATEWAY_OVERVIEW: [PermissionEnum.CLINIC_PRINTER_GATEWAY_SHOW],
  PRINTER_GATEWAY_CREATE: [PermissionEnum.CLINIC_PRINTER_GATEWAY_CREATE],
  PRINTER_GATEWAY_UPDATE: [PermissionEnum.CLINIC_PRINTER_GATEWAY_SHOW, PermissionEnum.CLINIC_PRINTER_GATEWAY_UPDATE],

  QUEUE_LIST: [PermissionEnum.QUEUE_LIST],
  QUEUE_OVERVIEW: [PermissionEnum.QUEUE_SHOW],
  QUEUE_CREATE: [PermissionEnum.QUEUE_CREATE],
  QUEUE_UPDATE: [PermissionEnum.QUEUE_SHOW, PermissionEnum.QUEUE_UPDATE],
  QUEUE_DISPLAY_LIST: [PermissionEnum.QUEUE_DISPLAY_LIST],
  QUEUE_DISPLAY_OVERVIEW: [PermissionEnum.QUEUE_DISPLAY_SHOW],
  QUEUE_DISPLAY_CREATE: [PermissionEnum.QUEUE_DISPLAY_CREATE],
  QUEUE_DISPLAY_UPDATE: [PermissionEnum.QUEUE_DISPLAY_SHOW, PermissionEnum.QUEUE_DISPLAY_UPDATE],

  ADMIN_MEDICAL_RECORD_TEMPLATE_LIST: [PermissionEnum.ADMIN_MEDICAL_RECORD_TEMPLATE_LIST],
  ADMIN_MEDICAL_RECORD_TEMPLATE_UPDATE: [
    PermissionEnum.ADMIN_MEDICAL_RECORD_TEMPLATE_SHOW,
    PermissionEnum.ADMIN_MEDICAL_RECORD_TEMPLATE_UPDATE,
  ],

  CASHIER_LIST: [PermissionEnum.CASHIER_LIST],
  CASHIER_CREATE: [PermissionEnum.CASHIER_CREATE],
  CASHIER_UPDATE: [PermissionEnum.CASHIER_SHOW, PermissionEnum.CASHIER_UPDATE],
  CASHIER_OVERVIEW: [PermissionEnum.CASHIER_SHOW],

  CLINIC_MANAGER_SHIFT_LIST: [PermissionEnum.CASHIER_SESSION_LIST],
  CLINIC_MANAGER_SHIFT_CALCULATION: [
    PermissionEnum.CASHIER_SESSION_SHOW,
    PermissionEnum.CASHIER_SESSION_UPDATE_MONEY_COUNT,
  ],
  CLINIC_MANAGER_SHIFT_REVIEW: [PermissionEnum.CASHIER_SESSION_SHOW, PermissionEnum.CASHIER_SESSION_END],

  REPORT_INVENTORY_STOCK: [PermissionEnum.REPORT_INVENTORY_STOCK_LIST],

  CART: [PermissionEnum.CART_SHOW],
  RETAIL_CART: [PermissionEnum.RETAIL_CART_SHOW],

  SALES_INVOICE_HISTORY: [PermissionEnum.CASHIER_SALES_INVOICE_LIST],
  SALES_INVOICE_DETAIL: [PermissionEnum.CASHIER_SALES_INVOICE_SHOW],

  CASHIER_OPTION_FOR_START_CASHIER_SESSION_FORM: [PermissionEnum.CASHIER_OPTION_FOR_START_CASHIER_SESSION_FORM],
  CASHIER_SESSION_CREATE: [PermissionEnum.CASHIER_SESSION_CREATE],
  CASHIER_SESSION_SHOW_ACTIVE: [PermissionEnum.CASHIER_SESSION_SHOW_ACTIVE],
  CASHIER_SESSION_CLOSE: [PermissionEnum.CASHIER_SESSION_CLOSE],

  CASHIER_DAILY_REPORT: [PermissionEnum.CASHIER_SUMMARY_CREATE],

  MEDICAL_DISPENSE_DETAIL: [PermissionEnum.MEDICINAL_DISPENSE_SHOW],
  MEDICINAL_DISPENSE_LIST: [PermissionEnum.MEDICINAL_DISPENSE_LIST],
  MEDICINAL_DISPENSE_PRESCRIPTION: [PermissionEnum.MEDICINAL_DISPENSE_SHOW],

  CLINIC_OTTOPAY_EDC_LIST: [PermissionEnum.CLINIC_OTTOPAY_EDC_LIST],

  PHARMACIST_LIST: [PermissionEnum.PHARMACIST_LIST],
  PHARMACIST_OVERVIEW: [PermissionEnum.PHARMACIST_SHOW],

  ADMIN_PHARMACIST_LIST: [PermissionEnum.ADMIN_PHARMACIST_LIST],
  ADMIN_PHARMACIST_CREATE: [PermissionEnum.ADMIN_PHARMACIST_CREATE],
  ADMIN_PHARMACIST_UPDATE: [PermissionEnum.ADMIN_PHARMACIST_UPDATE, PermissionEnum.ADMIN_PHARMACIST_SHOW],
  ADMIN_PHARMACIST_OVERVIEW: [PermissionEnum.ADMIN_PHARMACIST_SHOW],

  ADMIN_SUPPLIER_CREATE: [PermissionEnum.ADMIN_SUPPLIER_CREATE],
  ADMIN_SUPPLIER_LIST: [PermissionEnum.ADMIN_SUPPLIER_FETCH],
  ADMIN_SUPPLIER_OVERVIEW: [PermissionEnum.ADMIN_SUPPLIER_GET],
  ADMIN_SUPPLIER_UPDATE: [PermissionEnum.ADMIN_SUPPLIER_GET, PermissionEnum.ADMIN_SUPPLIER_UPDATE],

  ADMIN_TREATMENT_CATEGORIES_LIST: [PermissionEnum.ADMIN_TREATMENT_CATEGORY_LIST],

  ADMIN_EXAMINATION_CATEGORY_LIST: [PermissionEnum.ADMIN_EXAMINATION_CATEGORY_LIST],

  PRODUCT_RECEIVE_LIST: [PermissionEnum.PRODUCT_RECEIVE_LIST],
  PRODUCT_RECEIVE_OVERVIEW: [PermissionEnum.PRODUCT_RECEIVE_SHOW],
  PRODUCT_RECEIVE_CREATE: [PermissionEnum.PRODUCT_RECEIVE_CREATE],

  MEDICAL_TOOL_LIST: [PermissionEnum.ADMIN_MEDICAL_TOOL_LIST],
  MEDICAL_TOOL_CREATE: [PermissionEnum.ADMIN_MEDICAL_TOOL_CREATE],
  MEDICAL_TOOL_EDIT: [PermissionEnum.ADMIN_MEDICAL_TOOL_SHOW, PermissionEnum.ADMIN_MEDICAL_TOOL_UPDATE],
  MEDICAL_TOOL_OVERVIEW: [PermissionEnum.ADMIN_MEDICAL_TOOL_SHOW],
  ADMIN_RETAIL_PRODUCT_CATEGORY_LIST: [PermissionEnum.ADMIN_RETAIL_PRODUCT_CATEGORY_LIST],
  ADMIN_RETAIL_PRODUCT_LIST: [PermissionEnum.ADMIN_RETAIL_PRODUCT_LIST],
  ADMIN_RETAIL_PRODUCT_OVERVIEW: [PermissionEnum.ADMIN_RETAIL_PRODUCT_SHOW],
  ADMIN_RETAIL_PRODUCT_CREATE: [PermissionEnum.ADMIN_RETAIL_PRODUCT_CREATE],
  ADMIN_RETAIL_PRODUCT_UPDATE: [PermissionEnum.ADMIN_RETAIL_PRODUCT_UPDATE],

  RETAIL_INDEX: [PermissionEnum.PRODUCT_LIST_FOR_RETAIL_CART],

  ADMIN_BANK_CREATE: [PermissionEnum.ADMIN_BANK_CREATE],
  ADMIN_BANK_LIST: [PermissionEnum.ADMIN_BANK_LIST],
  ADMIN_BANK_SHOW: [PermissionEnum.ADMIN_BANK_SHOW],
  ADMIN_BANK_UPDATE: [PermissionEnum.ADMIN_BANK_UPDATE],
  ADMIN_BANK_DELETE: [PermissionEnum.ADMIN_BANK_DELETE],

  CASH_DEPOSIT_LIST: [PermissionEnum.CASH_DEPOSIT_LIST],

  SUMMARY_REPORT_LIST: [PermissionEnum.CASHIER_SUMMARY_LIST],
  SUMMARY_REPORT_DETAIL: [PermissionEnum.CASHIER_SUMMARY_SHOW],
  SUMMARY_REPORT_SESSION: [PermissionEnum.CASHIER_SUMMARY_SHOW_SESSION],
  SUMMARY_REPORT_SALES_INVOICE: [PermissionEnum.CASHIER_SUMMARY_SHOW_SALES_INVOICE],

  CLUSTER_MANAGER_SUMMARY_REPORT_LIST: [PermissionEnum.CLUSTER_MANAGER_CASHIER_SUMMARY_LIST],
  CLUSTER_MANAGER_SUMMARY_REPORT_DETAIL: [PermissionEnum.CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW],
  CLUSTER_MANAGER_SUMMARY_REPORT_SESSION: [PermissionEnum.CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW_SESSION],
  CLUSTER_MANAGER_SUMMARY_REPORT_SALES_INVOICE: [PermissionEnum.CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW_SALES_INVOICE],
  PRICE_TAGS: [PermissionEnum.PRODUCT_PRICE_TAG_DOWNLOAD],

  PRODUCT_ADJUSTMENT_LIST: [PermissionEnum.PRODUCT_ADJUSTMENT_LIST],
  PRODUCT_ADJUSTMENT_CREATE: [PermissionEnum.PRODUCT_ADJUSTMENT_CREATE],
  PRODUCT_ADJUSTMENT_OVERVIEW: [PermissionEnum.PRODUCT_ADJUSTMENT_SHOW],

  ADMIN_VOUCHER_GENERATE_RULE_LIST: [PermissionEnum.ADMIN_VOUCHER_GENERATE_RULE_LIST],
  ADMIN_VOUCHER_GENERATE_RULE_DETAIL: [PermissionEnum.ADMIN_VOUCHER_GENERATE_RULE_SHOW],
  ADMIN_VOUCHER_GENERATE_RULE_CREATE: [PermissionEnum.ADMIN_VOUCHER_GENERATE_RULE_CREATE],
  ADMIN_VOUCHER_GENERATE_RULE_UPDATE: [
    PermissionEnum.ADMIN_VOUCHER_GENERATE_RULE_SHOW,
    PermissionEnum.ADMIN_VOUCHER_GENERATE_RULE_UPDATE,
  ],

  PRODUCT_TRANSFER_LIST: [PermissionEnum.PRODUCT_TRANSFER_LIST],
  PRODUCT_TRANSFER_OVERVIEW: [PermissionEnum.PRODUCT_TRANSFER_SHOW],
  PRODUCT_TRANSFER_CREATE: [PermissionEnum.PRODUCT_TRANSFER_CREATE],

  ADMIN_VOUCHER_CODE_LIST: [PermissionEnum.ADMIN_VOUCHER_CODE_LIST],
  ADMIN_VOUCHER_CODE_CREATE: [PermissionEnum.ADMIN_VOUCHER_CODE_CREATE],
  ADMIN_VOUCHER_CODE_EDIT: [PermissionEnum.ADMIN_VOUCHER_CODE_UPDATE],
  ADMIN_VOUCHER_CODE_OVERVIEW: [PermissionEnum.ADMIN_VOUCHER_CODE_SHOW],

  ADMIN_CASH_DEPOSIT_LIST: [PermissionEnum.ADMIN_CASH_DEPOSIT_LIST],

  WAIVE_FEE_REPORT: [PermissionEnum.REPORT_WAIVE_FEE_DOWNLOAD],

  TREATMENT_LIST: [PermissionEnum.TREATMENT_LIST],
  TREATMENT_OVERVIEW: [PermissionEnum.TREATMENT_SHOW],

  EXAMINATION_LIST: [PermissionEnum.EXAMINATION_LIST],
  EXAMINATION_OVERVIEW: [PermissionEnum.EXAMINATION_SHOW],

  FINANCE_INVENTORY_REPORT: [PermissionEnum.REPORT_FINANCE_INVENTORY_LIST],

  REPORT_DAILY_TRANSACTION_LIST: [PermissionEnum.REPORT_DAILY_TRANSACTION_LIST],

  REPORT_MONTHLY_REVENUE_LIST: [PermissionEnum.REPORT_MONTHLY_REVENUE_LIST],

  REPORT_NET_PROMOTER_SCORE_LIST: [PermissionEnum.REPORT_NET_PROMOTER_SCORE_LIST],

  REPORT_SALES_LIST: [PermissionEnum.REPORT_SALES_LIST],

  REPORT_SERVIVE_PERFORMANCE_LIST: [PermissionEnum.REPORT_SERVICE_AND_PERFORMANCE_LIST],

  PRODUCT_INVENTORY_LIST: [PermissionEnum.PRODUCT_INVENTORY_LIST],
  PRODUCT_INVENTORY_ACTIVITY_LOG: [
    PermissionEnum.PRODUCT_INVENTORY_SHOW,
    PermissionEnum.PRODUCT_INVENTORY_LIST_ACTIVITY_LOG,
  ],

  PRODUCT_BUNDLING_LIST: [PermissionEnum.PRODUCT_BUNDLING_LIST],
  PRODUCT_BUNDLING_OVERVIEW: [PermissionEnum.PRODUCT_BUNDLING_SHOW],

  ADMIN_PRODUCT_BUNDLING_LIST: [PermissionEnum.ADMIN_PRODUCT_BUNDLING_LIST],
  ADMIN_PRODUCT_BUNDLING_CREATE: [PermissionEnum.ADMIN_PRODUCT_BUNDLING_CREATE],
  ADMIN_PRODUCT_BUNDLING_EDIT: [
    PermissionEnum.ADMIN_PRODUCT_BUNDLING_SHOW,
    PermissionEnum.ADMIN_PRODUCT_BUNDLING_UPDATE,
  ],
  ADMIN_PRODUCT_BUNDLING_OVERVIEW: [PermissionEnum.ADMIN_PRODUCT_BUNDLING_SHOW],

  ADMIN_PRODUCT_PROMOTION_LIST: [PermissionEnum.ADMIN_PRODUCT_PROMOTION_LIST],
  ADMIN_PRODUCT_PROMOTION_CREATE: [PermissionEnum.ADMIN_PRODUCT_PROMOTION_CREATE],
  ADMIN_PRODUCT_PROMOTION_EDIT: [
    PermissionEnum.ADMIN_PRODUCT_PROMOTION_SHOW,
    PermissionEnum.ADMIN_PRODUCT_PROMOTION_UPDATE,
    PermissionEnum.ADMIN_PRODUCT_BUNDLING_UPDATE_ENDED_AT,
  ],
  ADMIN_PRODUCT_PROMOTION_OVERVIEW: [PermissionEnum.ADMIN_PRODUCT_PROMOTION_SHOW],

  PRODUCT_PROMOTION_LIST: [PermissionEnum.PRODUCT_PROMOTION_LIST],
  PRODUCT_PROMOTION_OVERVIEW: [PermissionEnum.PRODUCT_PROMOTION_SHOW],

  CLINIC_MANAGER_SALES_INVOICE_LIST: [PermissionEnum.CLINIC_MANAGER_SALES_INVOICE_LIST],

  REPORT_MONTH_TO_DATE_SALES_LIST: [PermissionEnum.REPORT_MONTH_TO_DATE_SALES_LIST],

  ADMIN_GLOBAL_SETTING_LIST: [PermissionEnum.ADMIN_GLOBAL_SETTING_LIST],

  CLINIC_SETTING_LIST: [PermissionEnum.CLINIC_SETTING_LIST],

  ADMIN_INSURANCE_PAYOR_LIST: [PermissionEnum.ADMIN_INSURANCE_PAYOR_LIST],
  ADMIN_INSURANCE_PAYOR_CREATE: [PermissionEnum.ADMIN_INSURANCE_PAYOR_CREATE],
  ADMIN_INSURANCE_PAYOR_EDIT: [PermissionEnum.ADMIN_INSURANCE_PAYOR_UPDATE],
  ADMIN_INSURANCE_LIST: [PermissionEnum.ADMIN_INSURANCE_LIST],
  ADMIN_INSURANCE_CREATE: [PermissionEnum.ADMIN_INSURANCE_CREATE],
  ADMIN_INSURANCE_UPDATE: [PermissionEnum.ADMIN_INSURANCE_UPDATE],

  ADMIN_DEVELOPER_TOOLS: [PermissionEnum.ADMIN_DEVELOPER_TOOLS],

  ADMIN_BOOKING_HOLIDAY_LIST: [PermissionEnum.ADMIN_BOOKING_HOLIDAY_LIST],
  ADMIN_BOOKING_HOLIDAY_UPDATE: [PermissionEnum.ADMIN_BOOKING_HOLIDAY_UPDATE],
  ADMIN_BOOKING_HOLIDAY_CANCEL: [PermissionEnum.ADMIN_BOOKING_HOLIDAY_CANCEL],

  APPOINTMENT_DOCTOR_TIME_OFF_LIST: [PermissionEnum.DOCTOR_BOOKING_TIME_OFF_LIST_DOCTOR],
  APPOINTMENT_DOCTOR_TIME_OFF_DETAIL: [
    PermissionEnum.DOCTOR_BOOKING_TIME_OFF_LIST,
    PermissionEnum.CLINIC_BOOKING_TIME_GET_WITH_DOCTOR,
  ],

  CLINIC_BOOKING_CLOSED_TIME_LIST: [PermissionEnum.CLINIC_BOOKING_CLOSED_TIME_LIST],

  APPOINTMENT_TIME_SLOT_DOCTOR_LIST: [PermissionEnum.DOCTOR_BOOKING_TIME_SLOT_LIST_DOCTOR],
  APPOINTMENT_TIME_SLOT_DOCTOR_SCHEDULE_OVERVIEW: [
    PermissionEnum.DOCTOR_BOOKING_TIME_SLOT_GET_WITH_DOCTOR_TIME_SLOT,
    PermissionEnum.CLINIC_BOOKING_TIME_GET_WITH_DOCTOR,
  ],
  APPOINTMENT_TIME_SLOT_DOCTOR_SCHEDULE_EDIT: [PermissionEnum.DOCTOR_BOOKING_TIME_SLOT_UPDATE_DOCTOR_TIME_SLOT],

  PRODUCT_TRANSFER_CLINIC_INBOUND_LIST: [PermissionEnum.PRODUCT_TRANSFER_CLINIC_INBOUND_LIST],
  PRODUCT_TRANSFER_CLINIC_INBOUND_OVERVIEW: [PermissionEnum.PRODUCT_TRANSFER_CLINIC_INBOUND_SHOW],
  PRODUCT_TRANSFER_CLINIC_OUTBOUND_LIST: [PermissionEnum.PRODUCT_TRANSFER_CLINIC_OUTBOUND_LIST],

  ADMIN_RADIOGRAPHER_LIST: [PermissionEnum.ADMIN_RADIOGRAPHER_LIST],
  ADMIN_RADIOGRAPHER_OVERVIEW: [PermissionEnum.ADMIN_RADIOGRAPHER_SHOW],
  ADMIN_RADIOGRAPHER_CREATE: [PermissionEnum.ADMIN_RADIOGRAPHER_CREATE],
  ADMIN_RADIOGRAPHER_UPDATE: [PermissionEnum.ADMIN_RADIOGRAPHER_UPDATE],

  ADMIN_CLIENT_CORPORATE_LIST: [PermissionEnum.ADMIN_CLIENT_CORPORATE_LIST],
  ADMIN_CLIENT_CORPORATE_CREATE: [PermissionEnum.ADMIN_CLIENT_CORPORATE_CREATE],
  ADMIN_CLIENT_CORPORATE_UPDATE: [PermissionEnum.ADMIN_CLIENT_CORPORATE_UPDATE],
  ADMIN_CLIENT_CORPORATE_OVERVIEW: [PermissionEnum.ADMIN_CLIENT_CORPORATE_SHOW],

  DIAGNOSTIC_ANCILLARY_LIST: [PermissionEnum.DIAGNOSTIC_ANCILLARY_LIST],
  DIAGNOSTIC_ANCILLARY_OVERVIEW: [PermissionEnum.DIAGNOSTIC_ANCILLARY_SHOW],
  DIAGNOSTIC_ANCILLARY_CREATE: [PermissionEnum.DIAGNOSTIC_ANCILLARY_CREATE],

  DIAGNOSTIC_ANCILLARY_LIST_SUMMARY: [PermissionEnum.DIAGNOSTIC_ANCILLARY_LIST_SUMMARY],
  DIAGNOSTIC_ANCILLARY_SUMMARY_OVERVIEW: [PermissionEnum.DIAGNOSTIC_ANCILLARY_SHOW_SUMMARY],
  DIAGNOSTIC_ANCILLARY_LIST_ACTION: [PermissionEnum.DIAGNOSTIC_ANCILLARY_LIST_ACTION],

  DIAGNOSTIC_ANCILLARY_TEMPLATE_LIST: [PermissionEnum.DIAGNOSTIC_ANCILLARY_TEMPLATE_LIST],
  DIAGNOSTIC_ANCILLARY_TEMPLATE_OVERVIEW: [PermissionEnum.DIAGNOSTIC_ANCILLARY_TEMPLATE_SHOW],
  DIAGNOSTIC_ANCILLARY_TEMPLATE_CREATE: [PermissionEnum.DIAGNOSTIC_ANCILLARY_TEMPLATE_CREATE],
  DIAGNOSTIC_ANCILLARY_TEMPLATE_UPDATE: [PermissionEnum.DIAGNOSTIC_ANCILLARY_TEMPLATE_UPDATE],
}
